<template>
  <v-layout justify-center align-center>
    <v-progress-circular
      :size="100"
      :width="4"
      color="teal"
      indeterminate
    ></v-progress-circular>
  </v-layout>
</template>

<script>
export default {
  name: 'loader'
}
</script>

<style>

</style>
